import underscored from 'underscore.string/underscored';

angular.module('gym.components').directive('relationshipList', function() {
  return {
    restrict: 'E',
    template: require('templates/components/contacts/forms/relationship_list.html.slim'),
    scope: {
      contact: '=',
      relationships: '=',
      form: '=',
      archive: '&',
      editSection: '&'
    },
    controller: ["$scope", "$state", "ContactBadgeService", "NewContactService", function($scope, $state, ContactBadgeService, NewContactService) {
      $scope.contactType = function(rel) {
        return underscored(rel.related_contact_type + 's').toLowerCase();
      };
      $scope.contactBadgeClass = function(type, status) {
        return ContactBadgeService.get(type, status);
      };
      $scope.displayLinkToNewContactSelect = function() {
        return $scope.linkToNewContactSelectVisible = true;
      };
      $scope.hideLinkToNewContactSelect = function() {
        return $scope.linkToNewContactSelectVisible = false;
      };
      $scope.linkToNewContactParams = {
        contactType: 'members',
        relationshipForType: 'Child',
        relationshipForId: $scope.contact.id
      };
      $scope.contactTypes = [['members', 'Member'], ['prospects', 'Prospect'], ['non_attending_contacts', 'Non-attending contact']];
      return $scope.goToNewContact = function() {
        var params;
        NewContactService.clear();
        params = angular.extend({}, $scope.linkToNewContactParams);
        params.relationshipForType = encodeURIComponent($scope.linkToNewContactParams.relationshipForType);
        return $state.go('gym.contacts.new', params);
      };
    }]
  };
});
